import { render, staticRenderFns } from "./item.vue?vue&type=template&id=2ac456a7&scoped=true"
import script from "./item.vue?vue&type=script&lang=ts"
export * from "./item.vue?vue&type=script&lang=ts"
import style0 from "./item.vue?vue&type=style&index=0&id=2ac456a7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac456a7",
  null
  
)

export default component.exports